import {useNuxtApp} from '#app'
import {useCheckoutStore} from '~/store/checkout'
import {formatMoney} from '~/utils/money'

export function useMoneyFormatter() {
    const nuxtApp = useNuxtApp()

    const pinia = nuxtApp.$pinia

    let checkoutStore = null
    if (pinia) {
        checkoutStore = useCheckoutStore(pinia)
    } else {
        console.warn('Pinia instance is not available; using fallback currency.')
    }

    return (value: number, currencyCode?: string) => {
        const currency =
            currencyCode ||
            (checkoutStore && checkoutStore.$state.pi && checkoutStore.$state.pi.total.currency) || null
        return formatMoney(value, currency)
    }
}